const searchBar = document.getElementById('searchbar');
const searchInput = searchBar.querySelector('input');

const searchIcon = document.getElementById('searchbar__open');
const searchClose = document.getElementById('searchbar__close');
const searchClear = document.getElementById('searchbar__clear');

let searchState = false;
let prevFocusedElement = null;

// Searchbar icon button
searchIcon.onclick = function () {
  const navCheckbox = document.getElementById('primarynav');

  // Search and nav are both open
  if (navCheckbox.checked) {
    navCheckbox.checked = false; // Close navigation
    toggleSearchbarState(true); // Open search bar
  } else {
    toggleSearchbarState(!searchState); // Toggle search bar based on current state
  }
};

// Close searchbar button
searchClose.onclick = function () {
  toggleSearchbarState(false);
};

// Clear the search input field
searchClear.onclick = function () {
  searchInput.value = '';
};

 /**
  * Toggle the searchbar open or closed
  * @param {bool} state The new state of the searchbar
  */
function toggleSearchbarState(state) {
  // search bar opening
  if (state) {
    searchBar.classList.add('search__toggled');
    searchInput.focus();
  } else {
    searchBar.classList.remove('search__toggled');
    searchIcon.focus();
  }

  // Updated searchbar state
  searchState = state;
}
